<h2 mat-dialog-title>
    <mat-icon>info</mat-icon>
    About
</h2>

<mat-dialog-content>
    <div class="about-logo">
        <span class="about-appname">{{info.name}}</span>
        <span class="about-version">v{{info.version}}</span>
    </div>

    <div class="about-rows">
        <div class="about-row">
            <span class="about-label">Build date</span>
            <span class="about-value">{{info.buildDate | date: 'yyyy-MM-dd HH:mm:ss'}}</span>
        </div>
        <div class="about-row">
            <span class="about-label">Node version</span>
            <span class="about-value">{{info.nodeVersion}}</span>
        </div>
        <div class="about-row">
            <span class="about-label">Angular version</span>
            <span class="about-value">{{info.angularVersion}}</span>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="primary">OK</button>
</mat-dialog-actions>
